import * as React from 'react';
import type { EchoLikeStatsResponse } from '@/types/ratings';
import { BatchedEchoStatsContext } from './BatchedEchoStatsContext';

/**
 * Wraps a subtree with a pre-fetched stats map. Descendant
 * `useEchoStatsQuery` callers read from `statsByEchoId` instead of
 * issuing their own HTTP request, collapsing N per-echo fetches into
 * the one batch fetch the parent already made.
 */
export const BatchedEchoStatsProvider: React.FC<{
  statsByEchoId: Map<string, EchoLikeStatsResponse>;
  children: React.ReactNode;
}> = ({ statsByEchoId, children }) => (
  <BatchedEchoStatsContext.Provider value={statsByEchoId}>
    {children}
  </BatchedEchoStatsContext.Provider>
);
